import { isEqual } from '@utility/lodash';
import React from 'react';

export function withDeepMemo<P extends object>(Component: React.ComponentType<P>, customComparator?: (prev: Readonly<P>, next: Readonly<P>) => boolean): React.MemoExoticComponent<React.ComponentType<P>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const comparator = customComparator || ((prevProps: Readonly<P>, nextProps: Readonly<P>) => isEqual(prevProps as any, nextProps as any));
  return React.memo(Component, comparator);
}